(function () {
  'use strict';

  function initHero(section) {
    if (!section || section.dataset.dictacHeroInit) return;
    section.dataset.dictacHeroInit = 'true';

    requestAnimationFrame(function () {
      section.classList.add('dictac-hero--ready');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-dictac-hero]').forEach(initHero);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section =
      e.target.querySelector('[data-dictac-hero]') ||
      (e.target.matches('[data-dictac-hero]') ? e.target : null);
    if (section) initHero(section);
  });
})();
